import { render, staticRenderFns } from "./PointHistory.vue?vue&type=template&id=db0b6428&"
import script from "./PointHistory.vue?vue&type=script&lang=js&"
export * from "./PointHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports